
angular.module('bmsApp.employeeTeam').controller('EmployeeTeamIndexCtrl', [
	'$scope',
	'$timeout',
	'$log',
	'$q',
	'$ngBootbox',
	'notify',
	'EmployeeTeamSvc', function (
		$scope,
		$timeout,
		$log,
		$q,
		$ngBootbox,
		notify,
		EmployeeTeamSvc) {

		$scope.customColorOptions = {
			size: 30,
			total: 26,
			customColors:  ['#FFFFFF', '#F49AC2', '#CB99C9', '#C23B22', '#FFD1DC', '#DEA5A4', '#AEC6CF', '#77DD77', '#CFCFC4', '#B39EB5', '#FFB347', '#B19CD9', '#FF6961', '#03C03C', '#FDFD96', '#836953', '#779ECB', '#966FD6', '#7bd148', '#5484ed', '#a4bdfc', '#46d6db', '#7ae7bf', '#51b749', '#fbd75b', '#ffb878', '#ff887c', '#dc2127', '#dbadff', '#e1e1e1'],
			roundCorners: true
		};

		$scope.init = function () {
			$scope.weekDays = [];
			$scope.load();
			$scope.formvalidatorconfig = {
				submitHandler: function (form) {
					$scope.submitFormClick($scope.weekDays);
				}
			};
		};

		$scope.load = function () {
			$scope.loading = true;
			$scope.processing = false;
			var employeeTeamLoadPromise = EmployeeTeamSvc.load();
			var promises = [employeeTeamLoadPromise];
			$q.all(promises)
				.then(function (responses) {
					$scope.loading = false;
					$scope.weekDays = responses[0].data.week_days;
					angular.forEach($scope.weekDays[0].employees, function (value, key) {
						value.team_index = 1;
					});
				}, function (error) {
					$scope.loading = false;
					$log.error(error);
				});
		};

		$scope.submitFormClick = function (weekDays) {
			var totalWarnings = 0;
			angular.forEach(weekDays, function (weekDay, weekDayKey) {
				angular.forEach(weekDay.employee_teams, function (employeeTeam, employeeTeamKey) {
					totalWarnings += employeeTeam.warnings.length;
				});
			});
			if (totalWarnings > 0) {
				$ngBootbox.confirm('There are ' + totalWarnings + ' warnings, are you sure you want to do this?')
					.then(function () {
						$scope.submitForm(weekDays);
					});
			}
			else {
				$scope.submitForm(weekDays);
			}
		};

		$scope.submitForm = function (weekDays) {
			$scope.processing = true;
			EmployeeTeamSvc.update(weekDays)
				.then(function (response) {
					notify({
						message: 'Teams saved successfully'
					});
					$scope.load();
				}, function (error) {
					notify({
						message: error,
						classes: 'error'
					});
				})
				.finally(function () {
					$scope.processing = false;
				});
		};

		$scope.addEmployeeTeam = function (weekDay) {
			var employeeTeam = {
				warnings: []
			};
			weekDay.employee_teams.push(employeeTeam);
		};

		$scope.removeEmployeeTeam = function (weekDay, employeeTeam) {
			weekDay.employee_teams.splice(weekDay.employee_teams.indexOf(employeeTeam), 1);
			$scope.updateAssignedEmployees(weekDay);
		};

		$scope.updateAssignedEmployees = function (weekDay, employeeTeam) {
			employeeTeams = weekDay.employee_teams;
			weekDayEmployees = weekDay.employees;
			var usedEmployeeIds = [];

			// get the ids in use
			angular.forEach(employeeTeams, function (employeeTeam, employeeTeamKey) {
				angular.forEach(employeeTeam.employees, function (teamEmployee, teamEmployeeKey) {
					usedEmployeeIds.push(teamEmployee.id);
				});
			});

			// set used employee options
			angular.forEach(weekDayEmployees, function (employee, employeeKey) {
				if (usedEmployeeIds.indexOf(employee.id) >= 0) {
					employee.inUse = true;
				}
				else {
					employee.inUse = false;
				}
			});

			angular.forEach(employeeTeams, function (employeeTeam, employeeTeamKey) {
				$scope.employeeTeamWarnings(employeeTeam);
			});
		};

		$scope.employeeOptionCheckDisabled = function (currentTeam, employeeOption) {
			var teamEmployeeIds = [];
			angular.forEach(currentTeam.employees, function (employee, employeeKey) {
				teamEmployeeIds.push(employee.id);
			});
			if (employeeOption.inUse && teamEmployeeIds.indexOf(employeeOption.id) === -1) {
				// employee is part of another team, disable option
				return true;
			}
			else {
				// employee is in this team or no team, enable option
				return false;
			}
		};

		$scope.employeeTeamDriverOptions = function (weekDay) {
			angular.forEach(weekDay.employee_teams, function (employeeTeam, employeeTeamKey) {
				var drivers = [];
				var driverIds = [];
				angular.forEach(employeeTeam.employees, function (employee, employeeKey) {
					if (employee.driver) {
						drivers.push(employee);
						driverIds.push(employee.id);
					}
				});
				employeeTeam.drivers = drivers;
				if (angular.isObject(employeeTeam.preferred_driver) && angular.isUndefined(employeeTeam.preferred_driver.id) === false) {
					if (driverIds.indexOf(employeeTeam.preferred_driver.id) === -1) {
						employeeTeam.preferred_driver = {};
					}
				}
			});
		};

		$scope.employeeTeamLeaderWarning = function (employeeTeam) {
			var warning = true;
			angular.forEach(employeeTeam.employees, function (employee, employeeKey) {
				if (employee.team_leader) {
					warning = false;
				}
			});
			return warning;
		};

		$scope.employeeTeamDriverWarning = function (employeeTeam) {
			var warning = true;
			angular.forEach(employeeTeam.employees, function (employee, employeeKey) {
				if (employee.driver) {
					warning = false;
				}
			});
			return warning;
		};

		$scope.employeeTeamPreferredDriverWarning = function (employeeTeam) {
			var warning = false;
			var driverCount = 0;
			angular.forEach(employeeTeam.employees, function (employee, employeeKey) {
				if (employee.driver) {
					driverCount++;
				}
			});
			if (driverCount > 1 && (angular.isObject(employeeTeam.preferred_driver) && angular.isUndefined(employeeTeam.preferred_driver.id) === false) === false) {
				warning = true;
			}
			return warning;
		};

		$scope.employeeTeamWarnings = function (employeeTeam) {
			employeeTeam.warnings = [];
			if ($scope.employeeTeamLeaderWarning(employeeTeam)) {
				employeeTeam.warnings.push('No team leader selected.');
			}
			if ($scope.employeeTeamDriverWarning(employeeTeam)) {
				employeeTeam.warnings.push('No driver selected.');
			}
			if ($scope.employeeTeamPreferredDriverWarning(employeeTeam)) {
				employeeTeam.warnings.push('More than 1 driver, but no preferred driver selected.');
			}
		};

		$scope.weekDayInit = function (weekDay) {
			// this bit of code updating the available options must be ran after the employee select lists have initialised so that the disable options watch is triggered
			$timeout(function () {
				$scope.updateAssignedEmployees(weekDay);
				$scope.employeeTeamDriverOptions(weekDay)
			}, 0);
		};

		$scope.init();

	}]);
